import { NotificationSocketRepository } from "../repositories/NotificationSocketRepository";


export class NotificationDisconnectSocket {
	constructor(private repository: NotificationSocketRepository) {}
	execute(): Promise<void> {
		return this.repository.disconnectSocket();
	}
}
